type TdsModalProps = {
  handleClose(): void
  handleOK(): void
}

const TdsModalConfirm = ({ handleClose, handleOK }: TdsModalProps) => (
  <div
    role="dialog"
    data-backdrop-close="false"
    className="tds-modal tds-modal__dialog--medium"
    data-do-not-move="true"
    id="warning-modal"
    hidden
  >
    <div
      role="document"
      className="tds-modal__dialog-container"
      aria-labelledby="warning-modal-heading-md"
      aria-describedby="warning-modal-description-md"
    >
      <div className="tds-modal__dialog-header">
        <h2 className="tds-modal__dialog-title" id="warning-modal-heading-md">
          Warning
        </h2>
      </div>
      <div className="tds-modal__dialog-body">
        <div className="tds-modal__dialog-body-content" id="warning-modal-description-md">
            <p>The information you have entered so far will be lost.</p>
            <p>Press OK to Continue, or Cancel to remain on this page.</p>
        </div>
      </div>
      <div className="tds-modal__dialog-footer">
        <div className="tds-modal__dialog-button-container">
          <div className="tds-modal__dialog-button-layout">
            <button
              className="tds-button--primary tds-button--small"
              onClick={handleOK}
              data-dismiss="modal"
            >
              OK
            </button>
            <button
              className="tds-button--secondary tds-button--small"
              onClick={handleClose}
              data-dismiss="modal"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
      <button className="tds-modal__dismiss" aria-label="Dismiss dialog" type="button">
        <svg focusable="false">
          <use xlinkHref="/claimuploadcenter/icons/symbol-sprites.svg#x-1-12" />
        </svg>
      </button>
    </div>
  </div>
)

export { TdsModalConfirm }
